// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listItem_1Tf0y {
    cursor: pointer;
  }
  
  .listItem_1Tf0y:hover {
    background-color: var(--color-base100);
  }`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/views/AssetPairingValidation/LocatorPairingSelectionRenderer.css"],"names":[],"mappings":"AAAA;IACI,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC","sourcesContent":[".listItem {\n    cursor: pointer;\n  }\n  \n  .listItem:hover {\n    background-color: var(--color-base100);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItem": `listItem_1Tf0y`
};
export default ___CSS_LOADER_EXPORT___;
